import React, { lazy, useState, Suspense } from 'react'
import { Layout, UnderConstruction } from 'components'
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Container
} from 'reactstrap'

const FaqList = lazy(() => import('./FaqList'))
// const FaqConfig = lazy(() => import('./FaqConfig'))
// const FaqGradeConfig = lazy(() => import('./FaqGradeConfig'))
// const FaqAttendanceConfig = lazy(() => import('./FaqAttendanceConfig'))

function Faq (props) {
  return (
    <Layout>
      <Container className='page-content' fluid style={{ padding: 30 }}>
        <Row>
          <Suspense fallback={<div>Loading...</div>}>
            <FaqList />
          </Suspense>
        </Row>
      </Container>
    </Layout>
  )
}

export default Faq
